/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-lonely-if */

import React, { ChangeEvent, useContext, useState } from 'react';
import { Modal } from '@mui/material';
import MasterTable from './MasterTable';
import ContactColumns from './ContactColumns';
import ContactRow from './ContactRow';
import { useGetBrokersByGroupIdPagination } from 'api/bitedb/brokers/brokers.hooks';
import { GlobalContext } from 'providers/GlobalProvider';
import { RecipientType } from 'api/bitedb/brokers/brokers';
import { AddBrokerModal } from '../Modal/AddBroker';
import { EditBrokerModal } from '../Modal/EditBroker';
import DeleteCommonModal from 'components/Monitor/Modals/DeleteModal';
import ContactAPI from 'api/ContactAPI';

const ContactsTable: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [contactType, setContactType] = useState<RecipientType | undefined>(
    undefined,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isAddBrokerModalOpen, setIsAddBrokerModalOpen] = useState(false);
  const [isEditBrokerModalOpen, setIsEditBrokerModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingBrokerId, setEditingBrokerId] = useState<string>('');

  const handlePageChange = (e: ChangeEvent<unknown>, new_page: number) => {
    setCurrentPage(new_page);
  };

  const handleSort = (key: string) => {
    const newSortOrder = sortBy === key && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortBy(key);
    setSortOrder(newSortOrder);
  };

  const {
    data: brokerConnections,
    pagination: contactsPagination,
    isLoading: isLoading,
    refetch: refetchContacts,
  } = useGetBrokersByGroupIdPagination(
    cur_user?.selected_team?.id ?? '-1',
    localSearchTerm,
    {
      page: currentPage,
      limit: itemsPerPage,
      sortBy: sortBy,
      sortOrder: sortOrder,
      search: localSearchTerm,
      type: contactType,
    },
  );
  return (
    <div className='widget-item' style={{ width: '100%', marginTop: '15px' }}>
      <div className='widget-search'>
        <div className='widget-search-input'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
          >
            <path
              d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z'
              stroke='var(--text-classify)'
              strokeWidth='1.66667'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <input
            placeholder='Search Contacts'
            id='primary'
            type='text'
            className='screening-input-field-content'
            style={{ width: '680px' }}
            name='primary'
            value={localSearchTerm}
            onChange={(e) => {
              setLocalSearchTerm(e.target.value);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                // Additional action on Enter if needed
              }
            }}
          />
        </div>

        <div className='widget-search-input'>
          <select
            id='contactType'
            value={contactType}
            onChange={(e) => setContactType(e.target.value as RecipientType)}
          >
            <option value=''>Select contact type</option>
            <option value='customs_broker'>Customs Broker</option>
            <option value='erp_system'>ERP System</option>
            <option value='third_party_provider'>Third-Party Provider</option>
          </select>
        </div>
        <div
          className='btn-new-automate'
          onClick={() => setIsAddBrokerModalOpen(true)}
        >
          <div>+ New Contact</div>
        </div>
      </div>
      <div className='widget-content'>
        <MasterTable
          cols={
            <ContactColumns
              sortData={handleSort}
              sortConfig={{ key: sortBy, direction: sortOrder }}
            />
          }
          suppliersData={brokerConnections}
          selectedItems={[]}
          // Required prop, but this table has no selection behaviour wired up.
          setSelectedItems={() => undefined}
          loading={isLoading}
          currentPage={contactsPagination?.currentPage || 1}
          totalPages={contactsPagination?.totalPages || 1}
          onPageChange={handlePageChange}
          customRowComponent={(props: any) => (
            <ContactRow
              transaction={props.transaction}
              handleEdit={() => {
                setEditingBrokerId(props.transaction.id);
                setIsEditBrokerModalOpen(true);
              }}
              handleDelete={() => {
                setEditingBrokerId(props.transaction.id);
                setIsDeleteModalOpen(true);
              }}
            />
          )}
        />
      </div>
      <AddBrokerModal
        open={isAddBrokerModalOpen}
        handleClose={() => setIsAddBrokerModalOpen(false)}
        handleSave={() => refetchContacts()}
      />
      <EditBrokerModal
        open={isEditBrokerModalOpen}
        handleClose={() => {
          setIsEditBrokerModalOpen(false);
          setEditingBrokerId('');
        }}
        handleSave={() => refetchContacts()}
        id={editingBrokerId ?? ''}
      />
      <Modal
        open={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
        }}
      >
        <DeleteCommonModal
          handleClose={() => setIsDeleteModalOpen(false)}
          title='Delete Contact'
          paragraph='Are you sure you want to delete this contact? This action cannot be undone.'
          handleDelete={async () => {
            await ContactAPI.deleteContact(editingBrokerId);
            setEditingBrokerId('');
            setIsDeleteModalOpen(false);
            refetchContacts();
          }}
        />
      </Modal>
    </div>
  );
};

export default ContactsTable;
